/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"

export const sellingTimeDrawer = css`
  padding: 18px 24px 30px 24px;
  background-color: white;

  label {
    text-transform: uppercase;
  }
`

export const sellingTimeEditorDrawer = css`
  .ant-form-item {
    margin-bottom: 0;
  }

  .formContainer {
    padding: 0 24px 20px 24px;
    display: flex;
    flex-direction: column;
  }

  .form-section-container {
    padding: 20px;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    position: relative;
  }

  .availability-close-icon {
    position: absolute;
    top: 4px;
    right: 4px;
    opacity: 0.5;
    cursor: pointer;
  }

  .time-input-form-item {
    label {
      text-transform: unset;
      color: #707070 !important;
    }
    .ant-form-item-control {
      line-height: unset;
      margin-bottom: 8px;
    }
  }

  .time-input {
    width: 100%;
  }

  .dui-btn-link {
    font-weight: 500;
  }
`
